import { singleton } from "tsyringe";

import type { ClassDto } from "@/entities/class/domain/dtos";

export interface ClassBehaviorStructure {
    isBaseClass: (classDto: ClassDto) => boolean;
}

@singleton()
export class ClassBehavior implements ClassBehaviorStructure {
    public isBaseClass = (academyClass: ClassDto) => {
        if (!academyClass.isDeletable && !academyClass.isModifiable) {
            return true;
        }

        return false;
    };
}
